import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";
import { Dimmer } from "../spinner";

const headCells = [
  {
    id: "1",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Año</p>,
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Mes</p>,
    textAlign: "center",
  },
  {
    id: "8",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Concepto</p>,
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Monto</p>,
    textAlign: "center",
  },
  {
    id: "4",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Interes Mora</p>,
    textAlign: "center",
  },
  {
    id: "5",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Recargos</p>,
    textAlign: "center",
  },
  {
    id: "9",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Multa</p>,
    textAlign: "center",
  },
  {
    id: "10",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Total</p>,
    textAlign: "center",
  },
  {
    id: "6",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> N° Recibo</p>,
    textAlign: "center",
  },
  {
    id: "7",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Fecha Pago</p>,
    textAlign: "center",
  },
];

const TablaHistorico1x500 = (props) => {
  const [activate, setActivate] = useState(false);

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 280);

  const [url, setUrl] = useState("");

  useEffect(() => {
    if (props.tabpago) {
      setRecords(props.tabpago);
    }
  }, [props.tabpago]);

  return (
    <div className="card">
      <Dimmer active={activate} />
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow
                          key={item.anio + item.mes}
                          style={{ padding: "0" }}
                        >
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.anio}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.mes}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "left" }}
                          >
                            {item.concepto}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.intereses.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.recargo.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.multa.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.total.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.recibo === null ? "" : item.recibo.trim()}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechapago).format("DD/MM/YYYY")}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaHistorico1x500;



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/historicoDeuda1x500.js